import 'reflect-metadata'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import store from './store'
import Toasted from 'vue-toasted'
import VTooltip from 'v-tooltip'
import i18n from './i18n'
import '@/plugins/vue-fort-awasome'
import '@/plugins/vee-validate'
import '@/plugins/axios'
import '@/plugins/moment'
import moment from 'moment'
import { PromotionInput } from './services/connecteur'
Vue.config.productionTip = false

Vue.use(Toasted)
Vue.use(VTooltip)

declare global {
  interface Date {
    toJSON (): string
  }
}

// Preserve timezone when call api
PromotionInput.prototype.toJSON = function () {
  const result = {
    ...this
  }

  if (this.sellInStart) {
    // @ts-ignore
    result.sellInStart = moment(this.sellInStart).format()
  }

  if (this.sellInEnd) {
    // @ts-ignore
    result.sellInEnd = moment(this.sellInEnd).format()
  }

  if (this.sellOutStart) {
    // @ts-ignore
    result.sellOutStart = moment(this.sellOutStart).format()
  }

  if (this.sellOutEnd) {
    // @ts-ignore
    result.sellOutEnd = moment(this.sellOutEnd).format()
  }

  if (this.plannedDeliveryDate) {
    // @ts-ignore
    result.plannedDeliveryDate = moment(this.plannedDeliveryDate).format()
  }

  return result
}

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'

new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
